const defaultState = {
  client: {},
  routes: [],
  router: {}
}

const state = defaultState

const getters = {
  Client: state => {
    return state.client
  },
  Routes: state => {
    return state.routes
  },
  Router: state => {
    return state.router
  }
}

const mutations = {
  INIT_SESSION(state, obj) {
    state = JSON.parse(JSON.stringify(defaultState))
  },
  SAVE_SESSION(state, obj) {
    state[obj.name] = JSON.parse(JSON.stringify(obj.content))
  }
}

const actions = {
  InitSession({ commit }, payload) {
    commit('INIT_SESSION', payload)
  },
  SaveSession({ commit }, payload) {
    commit('SAVE_SESSION', payload)
  },
  UpdateRouter({ commit }, payload) {
    const router = state.router
    for (const key in payload) {
      router[key] = payload[key]
    }
    commit('SAVE_SESSION', { name: 'router', content: router })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
